module.exports = __webpack_public_path__ + "static/media/personality6.e0603bf3.jpeg";